import {
  FETCH_IP_BLOCKS_START,
  FETCH_IP_BLOCKS_SUCCESS,
  FETCH_IP_BLOCKS_ERROR,
  ADD_IP_BLOCK_START,
  ADD_IP_BLOCK_SUCCESS,
  ADD_IP_BLOCK_ERROR,
  ADD_IP_BLOCK_CLEAR,
  DELETE_IP_BLOCK_START,
  DELETE_IP_BLOCK_DONE,
} from "./actionTypes";

const initialState = {
  loading: false,
  error: "",
  docs: [],
  clearingCounter: 0,
  deleteClearingCounter: 0,
};

const ipAccessControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IP_BLOCKS_START:
      state = {
        ...state,
        loading: true,
      };
      break;
    case FETCH_IP_BLOCKS_SUCCESS:
      state = {
        ...state,
        docs: [...action.payload.docs],
        totalDocs: action.payload.totalDocs,
        hasNextPage: action.payload.hasNextPage,
        hasPrevPage: action.payload.hasPrevPage,
        limit: action.payload.limit,
        nextPage: action.payload.nextPage,
        page: action.payload.page,
        pagingCounter: action.payload.pagingCounter,
        prevPage: action.payload.prevPage,
        totalPages: action.payload.totalPages,
        loading: false,
      };
      break;
    case FETCH_IP_BLOCKS_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload.error
      };
      break;

    case ADD_IP_BLOCK_START:
      state = {
        ...state,
        addLoading: true,
      };
      break;
    case ADD_IP_BLOCK_SUCCESS:
      state = {
        ...state,
        addResult: action.payload,
        docs: [action.payload, ...state.docs],
        addSuccess: true,
        addError: false,
        addLoading: false,
      };
      break;
    case ADD_IP_BLOCK_ERROR:
      state = {
        ...state,
        addLoading: false,
        addErrorDetails: action.payload,
        addSuccess: false,
        addError: true,
      };
      break;
    case ADD_IP_BLOCK_CLEAR:
      state = {
        ...state,
        addErrorDetails: "",
        addSuccess: false,
        addError: false,
        addResult: null,
        clearingCounter: state.clearingCounter + 1
      };
      break;

    case DELETE_IP_BLOCK_START:
      state = {
        ...state,
        deleteLoading: true,
      };
      break;
    case DELETE_IP_BLOCK_DONE:
      state = {
        ...state,
        docs: state.docs.filter(obj => obj.ip !== action.payload.ip),
        deleteLoading: false,
        deleteResult: action.payload.result,
        deleteError: action.payload.error,
        deleteClearingCounter: state.deleteClearingCounter + 1,
      };
      break;
    default:
      state = { ...state };
  }
  return state;
};

export default ipAccessControlReducer;
